import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilityService } from '../../../core/services/utility/utility.service';
import { NgIf, NgSwitch, NgSwitchCase } from '@angular/common';
import { UserProfileManagerSidebarComponent } from '../user-profile-manager-sidebar/user-profile-manager-sidebar.component';
import { ManageUserInfoComponent } from '../manage-user-info/manage-user-info.component';
import { ManagePasswordComponent } from '../manage-password/manage-password.component';
import { ManageBillingComponent } from '../manage-billing/manage-billing.component';
import { ManageCompanionAccountComponent } from '../manage-companion-account/manage-companion-account.component';
import { ManageSavedBulletinsComponent } from '../manage-saved-bulletins/manage-saved-bulletins.component';
import { AccountRecoveryComponent } from '../account-recovery/account-recovery.component';
import { ManageDevicesComponent } from '../manage-devices/manage-devices.component';

@Component({
    selector: 'app-user-profile-manager',
    templateUrl: './user-profile-manager.component.html',
    styleUrls: ['./user-profile-manager.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        UserProfileManagerSidebarComponent,
        NgSwitch,
        NgSwitchCase,
        ManageUserInfoComponent,
        ManagePasswordComponent,
        ManageBillingComponent,
        ManageCompanionAccountComponent,
        ManageSavedBulletinsComponent,
        AccountRecoveryComponent,
        ManageDevicesComponent,
    ],
})
export class UserProfileManagerComponent implements OnInit {

  public screenWidth: number;
  public section: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private utilityService: UtilityService) {
    this.screenWidth = this.utilityService.getScreenWidth();
    this.section = this.route.snapshot.paramMap.get('section');
   }

  ngOnInit() {
    this.router.events.subscribe(event => {
      this.section = this.route.snapshot.paramMap.get('section');
    });
  }

}
